<template>
  <transition name="slide">
    <div class="popup-info" v-if="showFavor">
      {{ text }}
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'InfoPopup',
    props: {
      text: {
        default: '',
        type: String,
      },
      showFavor: {
        default: false,
        type: Boolean,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index.scss';
</style>
